var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mobile-apply-container"
  }, [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading,
      "tip": "加载中..."
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label required"
  }, [_vm._v("所属组织及岗位")]), _c('a-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位"
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObject.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organPostId", $$v);
      },
      expression: "formObject.organPostId"
    }
  })], 1), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label required"
  }, [_vm._v("概述")]), _c('a-input', {
    attrs: {
      "placeholder": "例: 教学用具",
      "max-length": 50
    },
    model: {
      value: _vm.formObject.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "summary", $$v);
      },
      expression: "formObject.summary"
    }
  })], 1), _c('div', {
    staticClass: "form-item form-item-plain"
  }, [_c('fm-generate-form', {
    ref: "generateForm",
    attrs: {
      "data": _vm.jsonData,
      "value": _vm.editData
    }
  })], 1), _c('div', {
    staticClass: "footer-buttons"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "block": "",
      "loading": _vm.submitting,
      "size": "large"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 提交申请 ")])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };